import { checkGate, getExperiment, getLayer } from '@eventbrite/statsig';
import {
    ConfirmationPageReferralExperimentVariant,
    ExpressOnlyCheckoutExperimentVariant,
    ExpressPaymentMethods,
    EXPRESS_CHECKOUT_ONLY_CHECKOUT_EXPERIMENT,
    FOLLOW_CARD_PLACEMENT_EXPERIMENT,
    GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
    ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT,
    PostCheckoutMandatoryCustomQuestionsVariant,
    PostCheckoutMandatoryQuestionsInAppVariant,
    POST_CHECKOUT_MANDATORY_CUSTOM_QUESTIONS,
    POST_CHECKOUT_MANDATORY_QUESTIONS_IN_APP,
} from '../constants/statsig';

export const checkEnablePayPalLineItemsFeatureGate = () =>
    checkGate('checkout_enable_paypal_line_items');

export const getFollowCardPlacementExperiment = () =>
    getLayer(
        FOLLOW_CARD_PLACEMENT_EXPERIMENT.layer,
        FOLLOW_CARD_PLACEMENT_EXPERIMENT.param,
        FOLLOW_CARD_PLACEMENT_EXPERIMENT.defaultValue,
    );

export const getGooglePayOnTicketSelectionExperimentValue =
    (): ExpressPaymentMethods =>
        getLayer(
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
        );

export const getPostCheckoutMandatoryCustomQuestions =
    (): PostCheckoutMandatoryCustomQuestionsVariant =>
        getLayer(
            POST_CHECKOUT_MANDATORY_CUSTOM_QUESTIONS.layer,
            POST_CHECKOUT_MANDATORY_CUSTOM_QUESTIONS.param,
            POST_CHECKOUT_MANDATORY_CUSTOM_QUESTIONS.defaultValue,
        );

export const getPostCheckoutMandatoryQuestionsInApp =
    (): PostCheckoutMandatoryQuestionsInAppVariant =>
        getLayer(
            POST_CHECKOUT_MANDATORY_QUESTIONS_IN_APP.layer,
            POST_CHECKOUT_MANDATORY_QUESTIONS_IN_APP.param,
            POST_CHECKOUT_MANDATORY_QUESTIONS_IN_APP.defaultValue,
        );

export const getReferralInOrderConfirmationExperiment =
    (): ConfirmationPageReferralExperimentVariant =>
        getExperiment(
            ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT.experiment,
            ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT.param,
            ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT.defaultValue,
        );

export const getExpressOnlyCheckoutExperiment =
    (): ExpressOnlyCheckoutExperimentVariant =>
        getLayer(
            EXPRESS_CHECKOUT_ONLY_CHECKOUT_EXPERIMENT.layer,
            EXPRESS_CHECKOUT_ONLY_CHECKOUT_EXPERIMENT.param,
            EXPRESS_CHECKOUT_ONLY_CHECKOUT_EXPERIMENT.defaultValue,
        );
